import React from 'react'
import { SvgIconProps } from '@mui/material'
import MicOutlinedIcon from '@mui/icons-material/MicOutlined'

// At-rest counterpart of the filled Mic. MicOutlined is nearly solid at icon sizes, too close to the
// filled glyph to tell apart, so the capsule (not the stand) is forced into a thin stroke.
// Targets MicOutlined's own two <path>s by position (capsule first, stand second), verified
// against @mui/icons-material 7.3.2 — a version bump that reorders or changes that glyph's
// markup would need this re-verified, since nth-of-type has no other way to tell them apart.
export const MicOutlineIcon: React.FC<Pick<SvgIconProps, 'fontSize'>> = ({ fontSize }) => (
    <MicOutlinedIcon
        fontSize={fontSize}
        sx={{
            // strokeWidth: 2 measured to produce the exact same rendered line thickness as
            // the stand's own solid stroke (16px at 4x scale for both), so the two halves
            // read as one consistent line weight.
            '& path:nth-of-type(1)': { fill: 'none', stroke: 'currentColor', strokeWidth: 2 },
            '& path:nth-of-type(2)': { fill: 'currentColor' },
        }}
    />
)
